module.exports = __webpack_public_path__ + "img/方块中级大师@2x.af880366.png";